import { lazyWithRetry } from 'utils/lazyWithRetry';
export const LazyRouterShell = lazyWithRetry(()=>import('./index').then(({ RouterShell })=>({
            default: RouterShell
        })));
export const LazyRouterShellComponent = lazyWithRetry(()=>import('./index').then(({ RouterShellComponent })=>({
            default: RouterShellComponent
        })));
